import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Observable, ReplaySubject } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class TranslateCollectorService {

    private myTranslationMap: any = {};

    private myLanguagesSubject: ReplaySubject<string[]> = new ReplaySubject<string[]>(1);

    constructor(private myTranslateService: TranslateService) {
    }

    public addTranslations(translation: any, lang: string, priority: number): void {
        if (this.myTranslationMap[ lang ] === null
            || typeof this.myTranslationMap[ lang ] === 'undefined') {
            this.myTranslationMap[ lang ] = [];
        }

        this.myTranslationMap[ lang ].push({ priority, translation });
        this.myTranslationMap[ lang ].sort((a: any, b: any) => {
            if (a.priority > b.priority) {
                return 1;
            } else {
                return -1;
            }
        });
        let merged: any = JSON.parse(localStorage.getItem(`${lang}_merged_${document.title}`));
        if (merged === null) {
            merged = {};
        }
        for (const translationsData of this.myTranslationMap[ lang ]) {
            const translations: any = translationsData.translation;
            if (translations != null) {
                Object.keys(translations).forEach((key: string) => {
                    merged[ key ] = translations[ key ];
                });
            }
        }

        let trans: boolean = true;
        let count: number = 0;

        while (trans) {
            count++;
            trans = false;
            if (count >= 10) {
                console.warn('Limit reached! Please check translation file! Last replaced values:');
            }
            Object.keys(merged).forEach((key: string) => {
                if (merged[ key ].startsWith('@:')) {
                    merged[ key ] = merged[ merged[ key ].substring(2, merged[ key ].length) ];
                    if (count < 10) {
                        trans = true;
                    } else {
                        trans = false;
                        console.warn(merged[ key ]);
                    }
                }
            });
        }
        localStorage.setItem(`${lang}_merged_${document.title}`, JSON.stringify(merged));
        this.myTranslateService.reloadLang(lang);
        const keys: string[] = [];
        for (const key in this.myTranslationMap) {
            keys.push(key);
        }
        this.myLanguagesSubject.next(keys);
    }

    public getLangSubject(): Observable<string[]> {
        return this.myLanguagesSubject.asObservable();
    }

    public getLangs(): string[] {
        const keys: string[] = [];
        for (const key in this.myTranslationMap) {
            keys.push(key);
        }
        return keys;
    }

    /** die gesamte Übersetzungs map*/
    public getCurrentLanguageMap(): any {
        return this.myTranslationMap;
    }

}
